import { connect } from "react-redux"
import { compose } from "redux"
import { withSnackbar } from "notistack"
import SetupMFA from "./SetupMFA"
import { verifyToken } from "../../../../store/actions/auth"

const mapDispatchToProps = (dispatch) => {
	return {
		verifyTotpToken: (user, code, password, authenticationStep) =>
			dispatch(verifyToken(user, code, password, authenticationStep)),
	}
}

export default compose(connect(null, mapDispatchToProps), withSnackbar)(SetupMFA)
